var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.043 0C5.00113 0 0 4.9152 0 10.957C0 16.9989 5.00113 22 11.043 22C17.0848 22 22 16.9989 22 10.957C22 4.9152 17.0848 0 11.043 0ZM14.9927 11.519L9.13378 17.3779C8.85169 17.66 8.39437 17.66 8.11229 17.3779L7.31096 16.5766C7.02887 16.2945 7.02887 15.8372 7.31096 15.5551L11.3458 11.5203C11.6561 11.21 11.654 10.7062 11.341 10.3986L7.31964 6.44484C7.03347 6.16348 7.03153 5.70281 7.3153 5.41905L8.11546 4.61888C8.39631 4.33804 8.85118 4.33662 9.13374 4.6157L14.9892 10.3986C15.301 10.7064 15.3025 11.2092 14.9927 11.519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.1d258c340e9a8c99a2dff2a498ee1550.svg";
export { ForwardRef as ReactComponent };